import Sidebar from '../../../components/Sidebar';
import Transitions from '../../../components/Transition';

import AppHeader from '../../../components/AppHeader';
import InputSearch from '../../../components/InputSearch';
import Loader from '../../../components/Loader/index';
import NoData from '../../../components/NoData';
import PageHeader from '../../../components/PageHeader';
import List from './components/List';
import ListHeader from './components/ListHeader';
import useBranches from './useBranches';

export default function Branches() {
  const {
    // userProfile,
    isLoading,
    companyCode,
    branches,
    apiFetched,
    searchTerm,
    handleChangeSearchTerm,
    filteredBranches,
    handleTryAgain,
  } = useBranches();

  const isEmpresaSelected = !!companyCode;
  const hasBranches = branches && apiFetched;
  const hasFilteredBranches = branches && apiFetched && filteredBranches?.length !== 0;
  const isSearchEmpty = filteredBranches?.length === 0 && apiFetched && !isLoading && branches.length > 0;
  const doesntHaveBranches = branches.length === 0 && apiFetched;

  return (
    <>
      <AppHeader isCompanySelectedDisabled={false} />
      <Sidebar active="Company" />
      <Transitions>
        <PageHeader
          title="Filiais"
          link="/company"
        />
        <Loader isLoading={isLoading} />

        {isEmpresaSelected && (
          <>
            {hasBranches && (
              <InputSearch
                searchTerm={searchTerm}
                handleChangeSearchTerm={handleChangeSearchTerm}
                placeholder="Pesquisar filial"
              />
            )}

            <ListHeader
              entity={branches}
              apiFetched={apiFetched}
              filteredEntity={filteredBranches}
              linkPath="/company/branches/new"
              entityString={{ singular: 'filial', plural: 'filiais' }}
            />

            {hasFilteredBranches && (
              <List
                filteredBranches={filteredBranches}
              />
            )}

            {isSearchEmpty && (
              <NoData
                icon="searchNotFound"
                label={(
                  <>
                Nenhum resultado foi encontrado para
                    {' '}
                    <strong>{searchTerm}</strong>
                  </>
                )}
              />
            )}

            {doesntHaveBranches && (
              <NoData
                icon="emptyBox"
                label={(
                  <>
                Esta empresa não tem nenhuma filial cadastrada, clique no botão
                    {' '}
                    <strong>Nova Filial</strong>
                    {' '}
                acima para cadastrar sua primeira!
                  </>
                )}
              />
            )}

            {(!apiFetched) && (
              <NoData
                icon="sad"
                label={(
                  <>
                Ocorreu um erro ao obter as filiais.
                    <button type="button" onClick={handleTryAgain}>Tentar Novamente</button>
                .
                  </>
                )}
              />
            )}
          </>
        )}

        {(!companyCode) && (
          <NoData
            icon="companyInterrogation"
            label={(
              <>
              Selecione uma empresa para visualizar os usuários.
              </>
            )}
          />
        )}

      </Transitions>
    </>
  );
}
